import React, { useState, useRef, useEffect } from 'react';
import {
  InfoTooltipWrapper,
  InfoTooltipIconButton,
  InfoTooltipBubble,
} from './InfoTooltip.styled';

const InfoTooltip = ({ content, shift = '-2rem' }) => {
  const [hovered, setHovered] = useState(false);
  const [pinned, setPinned] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setPinned(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <InfoTooltipWrapper ref={wrapperRef}>
      <InfoTooltipIconButton
        type="button"
        aria-label="More information"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => setPinned((p) => !p)}
      >
        i
      </InfoTooltipIconButton>
      <InfoTooltipBubble $show={hovered || pinned} $shift={shift}>
        {content}
      </InfoTooltipBubble>
    </InfoTooltipWrapper>
  );
};

export default InfoTooltip;
